import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import { IFormAgeOfMajority17 } from "../Models/Forms/IFormAgeOfMajority17";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';


import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';

@Injectable()
export class FormAgeOfMajority17Service extends BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string, ) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormAgeOfMajority17(id: number) {
    return this._http.get(this._baseUrl + "api/FormAgeOfMajority17/" + id)
      .map((response: IFormAgeOfMajority17) => response as IFormAgeOfMajority17)
      .catch(this.errorHandler)
  }

  validateForm(id: number) {
    return this._http.get(this._baseUrl + "api/FormAgeOfMajority17/ValidateForm" + id)
      .map((response: string[]) => response as string[])
      .catch(this.errorHandler)
  }

  insertUpdateFormAgeOfMajority17(formAgeOfMajority17Details:IFormAgeOfMajority17) {
    return this._http.post(this._baseUrl + 'api/FormAgeOfMajority17', formAgeOfMajority17Details)
      .map((response: IFormAgeOfMajority17) => response as IFormAgeOfMajority17)
      .catch(this.errorHandler);
  }

  deleteAgeOfMajority17(id) {
    return this._http.delete(this._baseUrl + "api/FormAgeOfMajority17" + id)
      .map((response: IFormAgeOfMajority17) => response as IFormAgeOfMajority17)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
}

